export enum TaskType {
  Task = 'task',
  Section = 'section',
}

export interface Task {
  createdBy?: string;
  updatedBy?: string;
  createdAt?: Date;
  updatedAt?: Date;
  id: string;
  assignee?: string;
  completionDate?: Date;
  description?: string;
  itemNumber?: string;
  dueDate?: string;
  decision?: Decision;
  dependency?: Dependency;
  dependencySource?: string;
  dependencyTarget?: string;
  isCompleted?: boolean;
  issue?: Issue;
  oneTimeCost?: number;
  name: string;
  parentId?: string | null;
  priority?: string;
  reporter?: string;
  risk?: Risk;
  startDate?: string;
  templateTaskId?: string;
  dealspaceId?: string;
  type: string;
  workspaceId?: string;
  playbookId?: string;
  comments?: Comment[];
  logs?: Log[];
  taskAttachments?: TaskAttachment[];
  sectionId?: string;
}

export interface Decision {
  decisionMade: string;
  decisionMaker: string[];
  updatedBy: string;
  id: string;
}

export interface Dependency {
  updatedBy: string;
}

export interface Issue {
  id: string;
  impact: string;
  updatedBy: string;
}

export interface Risk {
  impact: string;
  likelihood: string;
  id: string;
  updatedBy: string;
}

export interface Comment {
  createdBy: string;
  updatedBy: string;
  createdAt: Date;
  updatedAt: Date;
  id: string;
  comment: string;
  taskId: string;
  username: string;
}

export interface Log {
  columnName: string;
  description: string;
  newValue: string;
  oldValue: string;
  taskId: string;
  username: string;
  createdAt: Date;
}

export interface Document {
  id: string;
  createdAt: Date;
  fileType: string;
  key: string;
  name: string;
  size: number;
  url: string;
  username: string;
}

export interface TaskAttachment {
  id: string;
  createdAt: Date;
  document: Document;
  taskId: string;
}
